import { Injectable } from '@angular/core';
import { CompaniesEnum, RequestTypesEnum, StepsIdEnum } from '@app/core/models';

@Injectable({
  providedIn: 'root'
})
export class ConstantsService {
  public get localIISAppName(): string { return '.'; }
  public get localIISBaseUrl(): string { return `/${this.localIISAppName}/`; }
  public get requestStatusPattern(): RegExp { return /^[a-zA-Z0-9]*$/; }
  public get phoneNumberPattern(): RegExp { return /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/; }
  public get phoneNumberExtensionPattern(): RegExp { return /^\d*$/; }
  public get emailPattern(): RegExp { return /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/; }
  public get numericPattern(): RegExp { return /^[1-9][0-9]*$/; }
  public get numericPatternwithZero(): RegExp { return /^[0-9][0-9]*$/; }
  public get alphaNumericPattern(): RegExp { return /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/; }
  public get alphaPattern(): RegExp { return /^[A-Za-z\s\-]+$/; }
  public get phoneMask(): any { return ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]; }
  public get datePattern(): any { return /^\d{2}([./-])\d{2}\1\d{4}$/; }
  public get zipCodePattern(): RegExp { return /^\d{5}$/; }
  public get spacePattern(): RegExp { return /^(?!\s*$).+/; }
  public get alphaNumericNoSpacePattern(): RegExp { return /^([0-9A-Za-z]{1})[0-9A-Za-z\s\-]+$/; }
  public get dateValidator(): any {
    return /^(((((((0?[13578])|(1[02]))[\.\-/]?((0?[1-9])|([12]\d)|(3[01])))|(((0?[469])|(11))[\.\-/]?((0?[1-9])|([12]\d)|(30)))|((0?2)[\.\-/]?((0?[1-9])|(1\d)|(2[0-8]))))[\.\-/]?((\d{2})?([\d][\d]))))|((0?2)[\.\-/]?(29)[\.\-/]?(((19)|(20))?(([02468][048])|([13579][26])))))$/; }
  public get defaultLdc(): string { return CompaniesEnum.SC; }
  public get defaultRequestType(): string { return RequestTypesEnum.Residential; }
  public get defaultRequestStep(): number { return StepsIdEnum.LOCATION; }
  public get recaptchaSiteKey(): string { return '6LdPGV8UAAAAAKCUgYJFhKCB4YU0luFjDQjeeyy4'; }
  public get ApplicantUser(): string { return 'applicant'; }
  public get BuilderUser(): string { return 'builder'; }
  public get UserCookie(): string { return 'JwtCookie'; }
  public get changes(): string { return 'Changes you made may not be saved.'; }
  public get position(): string {return 'bottom'; }
  public get addMaxLot(): number { return 5; }
  public get folderName(): string { return 'Project Documents'; }
  public get builderMarketerAgreement(): string { return 'Builder Marketer Agreement'; }
  public get HeaderfolderName(): string { return 'Builder Header Documents'; }
  public get maxYear(): number { return 3; }
  public get resolverSwal(): string {
    return 'Something went wrong while loading application,the server might be unavailable. Please reload application or try again later.';
  }
  public get errorSwal(): string { return 'error'; }
  public get manualLotRequested(): string { return 'Y'; }
  public get warningSwal(): string { return 'warning'; }
  public get successSwal(): string { return 'success'; }
  public get successSwal1(): string { return 'Success!'; }
  public get wrongTypeCd(): string { return 'Cannot create lot for this gas request type'; }
  public get okSwal(): string { return 'ok'; }
  public get addressNotFoundSwal(): string { return 'Address Not Found'; }
  public get addressSwal1(): string { return 'Include more keyword or choose a location from the map.'; }
  public get addressSwal2(): string { return 'Address is not complete, please modify address.'; }
  public get contactCustomerCareSwal(): string { return 'Unable to process the request, Please contact customer care!!'; }
  public get invalidZipSwal(): string { return 'Invalid zip code!'; }
  public get premiseSwal1(): string { return 'No Appliances Checked'; }
  public get premiseSwal2(): string { return 'Please check at least one appliance'; }
  public get errorSwal1(): string { return 'Error!'; }
  public get commentsMandatorySwal(): string { return 'Comments are mandatory!'; }
  public get maxDocSize(): string { return 'Files larger than 50MB cannot be uploaded'; }
  public get wrongExt(): string { return 'Invalid extension of file'; }
  public get maxdocSwal(): string { return 'Maximum Five Files can be uploaded at a time'; }
  public get contractSwal(): string { return 'Please select all the items for download in order to proceed'; }
  public get congratsSwal(): string { return 'Congrats!'; }
  public get dataUpdatedSwal(): string { return 'Data updated!'; }
  public get sorrySwal(): string { return 'Sorry!'; }
  public get dataNotUpdated(): string { return 'Data could not be updated'; }
  public get okSwal1(): string { return 'Ok!'; }
  public get failedSwal(): string { return 'Failed'; }
  public get emptyListSwal(): string { return 'Please select files to delete'; }
  public get fileFolderDeleteFail(): string { return 'Unable to delete Folder'; }
  public get buildingTypeFail(): string { return 'Unable to fetch Building Type'; }
  public get builderInfoFail(): string { return 'Unable to fetch Builder Information'; }
  public get unitDescriptionError(): string { return 'Unit Description should be unique'; }
  public get contractInfoFail(): string { return 'Unable to retrieve Contract information'; }
  public get sessionswal(): string { return 'Sorry your session expired! Please login again to continue.'; }
  public get builderErrorSwal(): string { return 'Sorry you are not a Builder! Please login again with valid Builder Credentials.'; }
  public get gasAvailabilityLetterSwal(): string { return 'Gas Availability Letter Submitted!'; }
  public get GetgasAvailabilityLetterSwal(): string { return 'Unable to fetch Gas Availability Letter Details!'; }
  public get lotSwal1(): string { return 'Request for fetching Address details submitted!!'; }
  public get lotSwal2(): string { return 'Project address details not found!'; }
  public get subsidiaryDetailsFailSwal(): string { return 'Unable to fetch Subsidiary Details!'; }
  public get gasDetailsFailSwal(): string { return 'Unable to fetch address details!'; }
  public get lotSwal3(): string { return 'Only a maximum of five lots can be added'; }
  public get lotSwal4(): string { return 'Lot number should be unique, A lot already exists with same lot number'; }
  public get lotCreationReqSwal(): string { return 'Lot(s) creation request submitted!'; }
  public get developmentStatusReqSwal(): string { return 'Development status updated!'; }
  public get developmentStatusReqSwal1(): string { return 'Development status update!'; }
  public get lotCreationSuccessSwal(): string { return 'Lot(s) creation request has been submitted successfully!'; }
  public get developmentstatusSuccessSwal(): string { return 'Development status has been updated successfully!'; }
  public get lotCreationFailSwal(): string { return 'Lot(s) creation request failed!'; }
  public get subsidiaryAddSuccess(): string { return 'Successfully Added Subsidiary Company'; }
  public get builderUserAddSuccess(): string { return 'Thank you for registering with us, You will be notified once your request is approved and account is created.'; }
  public get builderUserAddFail(): string { return 'Unable to register the builder User.'; }
  public get builderUserAddWarning(): string { return 'Builder User already registered.'; }
  public get builderNewUserAdd(): string { return 'Successfully Added New Builder User.'; }
  public get builderCompanySubsidiaryAddWarning(): string { return 'Builder Company already added.'; }
  public get builderCompanyAddWarning(): string { return 'Builder Company already added. Please log in with existing username to add more users'; }
  public get builderCompanyAddFail(): string { return 'Unable to add Builder Company.'; }
  public get subsidiaryAddFail(): string { return 'Unable to add Subsidiary Company'; }
  public get subsidiaryAlreadyAdded(): string { return 'Already a Subsidiary Company'; }
  public get builderNotFound(): string { return 'Builder Company not found. Please fill up the details to add the Builder Company'; }
  public get headerDocReqSwal(): string { return 'No Documents Available!'; }
  public get isActive(): string {return 'N'; }
  public get contactTypeCode(): string {return 'B'; }
  public get subsidiaryAddNotAllowed(): string { return 'Builder Company cannot be added as Subsidiary'; }
  public get projDetailsError(): string { return 'Error in fetching Project Details'; }
  public get headerDocFailSwal(): string { return 'Please upload the documents manually or contact System Administrator'; }
  public get developmentStatusFailSwal(): string { return 'Development status update failed!'; }
  public get lotCreationReqNotSubSwal(): string { return 'Lot(s) creation request not submitted!!'; }
  public get checkAllFieldsSwal(): string { return 'Check all the fields!'; }
  public get paymentSwal(): string { return 'You would be navigated to Payment Gateway'; }
  public get fileUpload(): string { return ' cannot be uploaded since file is empty.No File has been uploaded.'; }
  public get fileUpload2(): string { return ' cannot be uploaded'; }
  public get infoSwal(): string { return 'info'; }
  public get postRequestFail(): string { return 'Unable to process your request'; }
  public get mainsFail(): string { return 'Unable to fetch Gas Mains data'; }
  public get docErrorSwal(): string { return ' Error in fetching Documents'; }
  public get fileUpload1(): string { return 'File/Files Uploaded Successfully!'; }
  public get fileUploadFail(): string { return 'Error in uploading file/files!'; }
  public get lotAllocationSwal1(): string { return 'Lot Allocation Request Updated'; }
  public get lotAllocationSwal2(): string { return 'Lot Allocation Request submitted successfully!'; }
  public get lotAllocationSwal3(): string { return 'Lot Allocation Request Failed!'; }
  public get getLotsFailsSwal(): string { return 'Unable to fetch lot details'; }
  public get enterReqDetailsSwal(): string { return 'Please enter all required details!'; }
  public get meterActDeactSwal(): string { return 'Meter Activation/Deactivation Request Submitted!'; }
  public get lotDetailsUpdateSwal(): string { return 'Lot details updated successfully!'; }
  public get serviceRequestSwal(): string { return 'Service Request Submitted!'; }
  public get siteContactDetailsAppliedSwal(): string { return 'Site Contact details applied!'; }
  public get selectLotToAdd(): string { return 'Please select lot(s) from Grid to update site contact details!'; }
  public get singleFamilyBuildingType(): string { return 'SF'; }
  public get mobileHomeBuildingType(): string { return 'MH'; }
  public get multiFamilyBuildingType(): string { return 'MF'; }
  public get industrialBuildingType(): string { return 'IF'; }
  public get bannermsgInfoComp(): string { return 'About You'; }
  public get bannermsgBuilderInfoComp(): string { return 'About You Builder'; }
  public get bannermsgLandingHome(): string { return 'Home'; }
  public get bannermsgLandingStatus(): string { return 'Gas Request Status'; }
  public get showDiscardmsgMultistep(): string { return 'Leaving this page will discard unsaved changes. Are you sure?'; }
  public get showDiscardmsgInvalidDataMultistep(): string { return 'You are leaving the page with some invalid fields. Are you sure?'; }
  public get grStatusMultistep(): string { return 'APPPEND'; }
  public get multi_Family(): string { return 'MULTI FAMILY'; }
   public get multi_Family1(): string { return 'Multi Family'; }
  public get Residential(): string { return 'Residential'; }
  public get single_Family(): string { return 'Single-Family Home'; }
  public get mobile_Home(): string { return 'Mobile Home'; }
  public get Industrial(): string { return 'INDUSTRIAL'; }
  public get Industrial1(): string { return 'Industrial'; }
  public get HomeSqFtQues(): string { return 'What is the approximate square footage of your home?'; }
  public get HomeSqFtBusinessQues(): string { return 'What is the approximate square footage of your business?'; }
  public get ApproxDistFtQues(): string { return 'What is the approximate distance (in ft.) from the street to the front of your home?'; }
  public get ApproxDistBusinessFtQues(): string {
    return 'What is the approximate distance (in ft.) from the street to the front of your business?';
  }
  public get totalUnits(): string { return 'Number of Units?'; }
  public get DeliveryPressureReqQues(): string { return 'What delivery pressure do you require?'; }
  public get NaturalGasInstlTypeQues(): string { return 'What Natural Gas appliances are you converting or installing in your home?'; }
  public get NaturalGasInstlTypeBusinessQues(): string {
    return 'What Natural Gas appliances are you converting or installing in your business?';
  }
  public get constructionStatusQues(): string { return 'What is the status of construction?'; }
  public get needingServiceQues(): string { return 'When do you anticipate needing service?'; }
  public get propertyOwnerQues(): string { return 'Are you the property owner?'; }
  public get marketerChosenQues(): string { return 'Have you chosen a Marketer?'; }
  public get marketerChoiceQues(): string { return 'Marketer of Choice'; }
  public get describeOthersQues(): string { return 'Describe Others'; }
  public get typeofApplicantRequestQues(): string { return 'What type of applicant is requesting natural gas service?'; }
  public get licensedBuilderQues(): string { return 'Are you a Licensed Builder?'; }
  public get meterOutsideHomeQues(): string { return 'Do you have a natural gas meter outside your home?'; }
  public get meterOutsideBusinessQues(): string { return 'Do you have a natural gas meter outside your business?'; }
  public get additionalMeterQues(): string { return 'Are you requesting an additional natural gas meter for this home?'; }
  public get additionalMeterBusinessQues(): string { return 'Are you requesting an additional natural gas meter for this business?'; }
  public get addReplacemeterQues(): string { return 'Are you adding or replacing natural gas appliances or equipment in your home?'; }
  public get addReplacemeterBusinesQues(): string {
    return 'Are you adding or replacing natural gas appliances or equipment in your business?';
  }
  public get newConstructionQues(): string { return 'Is this new construction?'; }
  public get typeofHomeQues(): string { return 'What type of home do you have?'; }
  public get currentEnergySourceQues(): string { return 'What is the current energy source for your appliance(s)?'; }
  public get meterOutsideBuildingQues(): string { return 'Do you have a natural gas meter outside your building?'; }
  public get propertyTypeQues(): string { return 'What type of property are you requesting Natural Gas Service for?'; }
  public get premisePropertyTypeQues(): string { return 'What type of property are you requesting natural gas service for?'; }
  public get poBoxPrefix(): string { return 'PO BOX'; }
  public get TimeZone(): string { return this.isDST ?  'UTC-400' : 'UTC-500'; }
  public get poolHeater(): string { return 'POOL HEATER'; }
  public get centralHeat(): string { return 'CENTRAL HEAT'; }
  public get standbyGenerator(): string { return 'Standby Generator'; }
  public get standbyGenerator2(): string { return 'STANDBY GENERATOR'; }
  public get otherAppliance(): string { return 'OTHER'; }
  public get serviceProvideCnfirmMsg(): string {
    return '<strong>This address is in our service area. <strong><p> Natural gas service is not guaranteed. Please request service and a Gas representative will contact you to confirm service availability and cost details.</p>';
  }
  public get georgiaServiceProvideCnfirmMsg(): string {
    return '<strong>This address is in our service area. <strong><p> Natural gas service is not guaranteed. Please request service and a Atlanta Gas representative will contact you to confirm service availability and cost details.</p>';
  }
  public get tennesseeServiceProvideCnfirmMsg(): string {
    return '<strong>This address is in our service area. <strong><p> Natural gas service is not guaranteed. Please request service and a Chattanooga Gas representative will contact you to confirm service availability and cost details.</p>';
  }
  public get virginiaServiceProvideCnfirmMsg(): string {
    return '<strong>This address is in our service area. <strong><p> Natural gas service is not guaranteed. Please request service and a Virginia Gas representative will contact you to confirm service availability and cost details.</p>';
  }
  public get addressSelectedForNewBCA(): string { return 'AddressSelectedForNewBCA'; }
  public get serviceableAreaCheck(): string { return 'ServiceableAreaChecked'; }
  public get requestSelectedForCreate(): string { return 'RequestSelectedForCreate'; }
  public get sorryNotificationText(): string {
    return '<div class="content-group"><p><strong>Unfortunately, we cannot provide natural gas service to your address because' +
    ' it is outside of our service territory.</strong></div>';
  }
  public get sorryNotificationTextAGL(): string {
    return '<div class="content-group"><p><strong>Unfortunately, we cannot provide natural gas service to your address because ' +
    'it is outside of our service territory. Please <a target="_blank" ' +
    'href="http://www.psc.state.ga.us/content.aspx?c=/list-of-certified-marketers-and-contact-information/">click here</a>' +
    'to choose from a list of certified natural gas marketers who can provide service to your address.</strong></div>';
  }
  public get contractAcceptMsg(): string {
    return 'Thanks for accepting the contract, please click on Back button to go back to contract page.';
  }
  public get contractRejectMsg(): string {
    return 'Thanks for the update on contract, please click on Back button to go back to contract page.';
  }
  public get bannermsgContractAccept(): string { return 'Contract Accepted'; }
  public get bannermsgAgrements(): string { return 'Marketer Agreements'; }
  public get gasReqTypeSubd(): string { return 'SUBD'; }
  public get gasReqTypeScatt(): string { return 'SCATT'; }
  public get dupFileMsg(): string { return '<strong>There is a same file/files with the name,<strong><p>Would you like to overwrite!</p>'; }
  public get howToDoc(): string { return 'HOW TO DOCUMENT'; }
  public get multiFamilyChecklist(): string { return 'MULTIFAMILY CHECKLIST'; }
  public get builderChecklist(): string { return 'BUILDER CHECKLIST'; }
  public get activationRequested(): string { return 'Activation Requested'; }
  public get activationApproved(): string { return 'Activation Approved'; }
  public get deactivationRequested(): string { return 'Deactivation Approved'; }
  public get deactivationApproved(): string { return 'Deactivation Approved'; }

  public get bcaNoCntrctRcvd(): string { return 'BCA Id you entered has no Contract received. Please try with other BCA Id.'; }
  public get bcaNotApproved(): string { return 'BCA should be Approved to create Work Requests. Please Approve BCA and try again.'; }
  public get bcaNoActivePermit(): string { return 'BCA Number you selected has no Active Permit. Please try with other BCA Number.'; }
  public get errorBcaStatusFetch(): string { return 'An error occurred while fetching the BCA Details. Please try again.'; }
  public get errorBcaNotExists(): string { return 'Entered BCA Id doesn\'t exists. Please enter other BCA Id'; }
  public get errorBcaDetailsFetch(): string { return 'An error occurred while fetching the BCA Details. Please try again.'; }
  public get errorWhenReqWR(): string { return 'Error occurred while requesting WR. Please try again'; }
  public get errorWhenBIdsFetch(): string { return 'An error occurred while fetching the Building Ids. Please try again.'; }
  public get noBcaSwal(): string { return 'Please enter BCA Id and try again'; }
  public get workRequestByBcaFail(): string { return 'Unable to get Work Requests for the Project Number. Please try again.'; }
  public get requestUpdateBuildingId(): string { return 'Unable to update  Building Ids. Please try again.'; }
  public get bIdsUpdatedMsg(): string { return ' building Ids have been updated for Gas request with BCA Id: '; }
  public get containerIdMsg(): string { return 'ContainerAwaiter'; }
  public get processingMsg(): string { return 'Processing..'; }
  public get requestAddBuildingId(): string { return 'Unable to add  Building Ids. Please try again.'; }
  public get bIdsAddedMsg(): string { return ' building Ids have been added for Gas request with BCA Id: '; }
  public get noBIdsAvailable(): string { return 'No building Ids available in GIS for Gas request with BCA Id: '; }
  public get bIdsAddedAndMsg(): string { return ' building Ids have been added and '; }
  public get noneText(): string { return 'None'; }

  // multistep ques subdivision
  public get naturalGasBusinessQ(): string {
    return 'What Natural Gas appliances are you converting or installing in your business?';
  }
  public get approximateDistQues(): string {
    return 'What is the approximate distance (in ft.) from the street to the front of your business?';
  }
  public get streetTypeQues(): string { return 'What type of streets will be in your development'; }
  public get numberofHomesQues(): string { return 'Total number of homes planned for development'; }
  public get approxSqFtQues(): string { return 'What is the approximate square footage of each home?'; }
  public get utilityEasementQues(): string { return 'Will you provide a utility easement?'; }
  public get approxdisthomeQues(): string {
    return 'What is the approximate distance (in ft.) from the street to the front of each home?';
  }
  public get siteplanAttach(): string { return 'Attach site plan(s)/plat with Lot list'; }
  public get electProviderQues(): string { return 'Who is the electric provider for the home?'; }
  public get streetCurbsQues(): string { return 'When will street curbs be installed and backfilled?'; }
  public get appliancesPerHome(): string { return 'Appliance(s) (per Home)'; }
  public get ContractDocType(): string { return 'CONTRACT'; }
  public get DrawingDocType(): string { return 'DRAWING'; }
  public get NotesDocType(): string { return 'NOTES'; }
  public get SketchDocType(): string { return 'SKETCH'; }
  public get LaserficheContractFolder(): string { return 'WR'; }
  public get contractDocFailSwal(): string { return 'No records were found for the selected category'; }
  public get exceptionError(): string {
    return 'Something went wrong, the server might be unavailable.' +
      ' Please reload application or try again later.';
  }
  public get addressNotFound(): string {
    return 'Your address does not appear on the map. Please move pin to closest address to your new residence / business.';
  }
  public get UnitDescription(): string { return 'Unit Description'; }
  public get multiFamilyHome(): string { return 'What type of Multi-Family home do you have?'; }

  public get industrialType(): string { return 'Industrial'; }
  public get residentialType(): string { return 'Residential'; }
  public get commercialType(): string { return 'Commercial'; }
  public get multiFamilyType(): string { return 'Multi Family'; }
  public get acknowledge(): string { return 'Acknowledge'; }
  public get other(): string { return 'OTHER'; }
  public get btuLoadOption(): string { return 'BTU Load Value (Optional)'; }
  public get btuLoad(): string { return 'BTU Load Value'; }
  public get rejected(): string { return 'Rejected'; }
  public get accepted(): string { return 'Accepted'; }
  public get CONRCVD(): string { return 'CONRCVD'; }
  public get CONRJTD(): string { return 'CONRJTD'; }
  public get noSubFound(): string { return 'No subsidiary found'; }
  public get PoolHeater(): string { return 'Pool Heater'; }
  public get selectAllocation(): string { return 'Please select lots for allocation'; }
  public get unknownRequest(): string { return 'Unknown request status received from server, '; }
  public get siteDetailsBuilder(): string { return 'Site Details Builder'; }
  public get builderHome(): string { return 'Builder Home'; }
  public get builderGasLetter(): string { return 'Builder Gas Letter'; }
  public get error2(): string { return 'Error'; }
  public get stay(): string { return 'Stay'; }
  public get discardChanges(): string { return 'Discard Changes'; }
  public get locationBuilder(): string { return 'Location Builder'; }
  public get georgia(): string {
    return 'Georgia';
  }
  public get main(): string { return 'main'; }
  public get reviewBuilder(): string { return 'Review Builder'; }
  public get subsidiary(): string { return 'Subsidiary'; }
  public get company(): string { return 'Company'; }
  public get gasLetterRequest(): string { return 'Gas Letter Request'; }
  public get PENDCONTR(): string { return 'PENDCONTR'; }
  public get PENDPMNT(): string { return 'PENDPMNT'; }
  public get PENDPRMT(): string { return 'PENDPRMT'; }
  public get PENDINST(): string { return 'PENDINST'; }
  public get COMP(): string { return 'COMP'; }
  public get Yes(): string {
    return 'Yes';
  }
  public get OTHERNOALLOW(): string {
    return 'OTHER(NO ALLOWABLE)';
  }
  public get No(): string {
    return 'No';
  }
  public get PopUp(): string {
    return 'PopUp';
  }
  public get block(): string {
    return 'block';
  }
  public get none(): string {
    return 'none';
  }
  public get searchCriteria(): string {
    return 'Please enter at least one search criteria.';
  }
  public get False(): string {
    return 'False';
  }
  public get activateSubmitted(): string {
    return 'Activation Request already Submitted';
  }
  public get activateApproved(): string {
    return 'Activation Request already Approved';
  }
  public get deactivateSubmitted(): string {
    return 'Deactivation Request already Submitted';
  }
  public get deactivateApproved(): string {
    return 'Deactivation Request already Approved';
  }
  public get service(): string {
    return 'service';
  }
  public get bcaAgreements(): string {
    return 'bca-agreements';
  }
  public get Allocated(): string {
    return 'Allocated';
  }
  public get Requested(): string {
    return 'Requested';
  }
  constructor() { }
  public get isDST(): boolean {
    const DateObj = new Date();
    const jan = new Date(DateObj.getFullYear(), 0, 1).getTimezoneOffset();
    const jul = new Date(DateObj.getFullYear(), 6, 1).getTimezoneOffset();
    return Math.max(jan, jul) !== DateObj.getTimezoneOffset();
  }
}
